import { Divider } from "@/shared/base/components/Divider/Divider";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import { Box, Stack, Typography, useTheme } from "@mui/material";

export function BucketCard(props: {
  children: React.ReactNode;
  title: string;
}) {
  const theme = useTheme();

  return (
    <Stack spacing={4}>
      {props?.title ? (
        <Box>
          <Divider>
            <Box
              bgcolor={theme.palette.background.default}
              width={"fit-content"}
              pr={4}
            >
              <Typography variant="h6" fontWeight={"700"} color="text.primary">
                {props.title}
              </Typography>
            </Box>
          </Divider>
        </Box>
      ) : null}

      <Box>{props.children}</Box>
    </Stack>
  );
}
